export default __webpack_public_path__ + "static/media/yourtarot-logo.0e445504.png";